<template>
  <section id="app">
    <router-view v-if="loaded"/>
  </section>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  import Vue from "vue";
  import TextureLibrary from "@/lib/texture-library";

  export default {
    // SETUP FIREFLY JARS
    data() {
      return {
        loaded: false
      };
    },
    computed: {
      ...mapState({
        jars: state => state.fireflies.jars,
        patterns: state => state.patterns.patterns,
        types: state => state.types.types
      })
    },
    methods: {
      ...mapActions([
        "getNewJars",
        "getTypes",
        "getItems",
        "getElements",
        "getPatterns",
        "getLocations",
        "getTreeColors"
      ])
    },
    created() {
      // Preload resources
      let loader = this.getLocations()
        .then(this.getItems)
        .then(this.getElements)
        .then(this.getTypes)
        .then(this.getPatterns)
        .then(this.getTreeColors);

      if (this.jars.length === 0) {
        loader = loader.then(this.getNewJars);
      }

      loader.then(_ => {
        Vue.prototype.$textures = new TextureLibrary(this.patterns, this.types);
        this.loaded = true;
      });
    }
  };
</script>


<style lang="scss">
  // Import Bulma's core
  @import "~bulma/sass/utilities/_all";
  @import "@/assets/global.scss";

  // Font
  @import url("https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700,700i");
  $family-primary: "Josefin Sans";

  // Import Bulma and Buefy styles
  @import "~bulma";
  @import "~buefy/src/scss/buefy";
  @import "@/assets/app.scss";
</style>
